export const API_RETRIEVAL_TIME = "API_RETRIEVAL_TIME";
export const API_TIMESTAMP = "API_TIMESTAMP";
export const LOCAL_IP = "LOCAL_IP";
export const LOCAL_IP_PROTOCOL = "LOCAL_IP_PROTOCOL";
export const WAN_IP = "WAN_IP";
export const WAN_IP_PROTOCOL = "WAN_IP_PROTOCOL";
export const MODEL = "MODEL";
export const SERIAL_NUMBER = "SERIAL_NUMBER";
export const IMEI = "IMEI";
export const IMSI = "IMSI";
export const ICCID = "ICCID";
export const MSISDN = "MSISDN";
export const HARDWARE_VERSION = "HARDWARE_VERSION";
export const SOFTWARE_VERSION = "SOFTWARE_VERSION";
export const BEARER = "BEARER";
export const NETSTAT = "NETSTAT";
export const SIM_STATUS = "SIM_STATUS";
export const WIFI_USERS = "WIFI_USERS";
export const WIFI_STATUS = "WIFI_STATUS";
export const WIFI_SSID = "WIFI_SSID";
export const WIFI_CHANNEL = "WIFI_CHANNEL";
export const WIFI_BANDWIDTH = "WIFI_BANDWIDTH";
export const PCI = "PCI";
export const PSC = "PSC";
export const CELL_ID = "CELL_ID";
export const CELL_ID_4G = "CELL_ID_4G";
export const LAC = "LAC";
export const RSRQ = "RSRQ";
export const RSRP = "RSRP";
export const RSSI = "RSSI";
export const SNR = "SNR";
export const RSCP = "RSCP";
export const ECNO = "ECNO";
export const MNC = "MNC";
export const MCC = "MCC";
export const BRAND = "BRAND";
export const TIMESTAMP = "TIMESTAMP";
export const DL_BANDWIDTH = "DL_BANDWIDTH";
export const EARFCN = "EARFCN";
export const RAD_BAND = "RAD_BAND";















// WEBPACK FOOTER //
// ./js/core/gateway/service/modules/kpi/enums/RawKpiConstants.js